import { render } from "./WebsiteView.vue?vue&type=template&id=0ef24cb4&ts=true"
import script from "./WebsiteView.vue?vue&type=script&lang=ts"
export * from "./WebsiteView.vue?vue&type=script&lang=ts"

import "./WebsiteView.vue?vue&type=style&index=0&id=0ef24cb4&lang=scss"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__